import { type FC, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { CookieGeoText } from '@/components/modals/CookiesModal/CookieGeoText';
import { useCookieGeoCountry } from '@/components/modals/CookiesModal/hooks';
import { getCtaButtonHrefWithSessionId } from '@/modules/promo';
import { Button } from '../../../../components/buttons';

import { ScCookiePopup } from './styled';

interface CookiePopupProps {
  translation: string;
  claimButtonMode?: 'primary' | 'orangeRedGradient';
}

export const CookiePopup: FC<CookiePopupProps> = ({
  translation,
  claimButtonMode,
}) => {
  const { t } = useTranslation(translation);
  const geoCountry = useCookieGeoCountry();

  const claimButtonProps = useMemo(() => {
    switch (claimButtonMode) {
      case 'orangeRedGradient':
        return {
          orangeRedGradient: true,
        };
      default:
        return {
          primary: true,
        };
    }
  }, [claimButtonMode]);
  return (
    <ScCookiePopup>
      {geoCountry ? (
        <div>
          <CookieGeoText country={geoCountry} />
        </div>
      ) : (
        <p>{t('cookie')}</p>
      )}
      <Button
        {...claimButtonProps}
        href={getCtaButtonHrefWithSessionId()}
        paddingX={12}
        target="_self"
        xSmall
      >
        accept
      </Button>
    </ScCookiePopup>
  );
};
